import axios, { type AxiosRequestConfig } from 'axios';

import type { TokenResult } from '../authService';
import authServiceFactory from '../authServiceFactory';
import configurationService from '../configurationService';

const noParse = (json: string) => json;

class AdCenterApiService {
  _getConfig(
    token: TokenResult,
    contentType: string = 'application/json;charset=UTF-8',
  ): AxiosRequestConfig {
    return {
      headers: {
        'Content-Type': contentType,
        ...(configurationService.isLocalDev()
          ? {}
          : { 'X-Requested-With': 'XMLHttpRequest' }),
        ...(typeof token === 'string'
          ? { Authorization: `Bearer ${token}` }
          : {}),
      },
    };
  }

  async post(
    url: string,
    body: any,
    transformerFunction: (data: any) => any = noParse, // TODO_TYPES: can we improve this? do we need to?
    useFormDataHeader: boolean = false,
  ) {
    const authService = authServiceFactory();
    const token = await authService.getToken();

    return axios
      .post(
        url,
        body,
        this._getConfig(
          token,
          useFormDataHeader ? 'multipart/form-data' : undefined,
        ),
      )
      .then((response) => response.data)
      .then((json) => transformerFunction(json));
  }

  async get(url: string) {
    const authService = authServiceFactory();
    const token = await authService.getToken();

    return axios
      .get(url, this._getConfig(token))
      .then((response) => response.data);
  }
}

export default new AdCenterApiService();
